<app-toolbar> </app-toolbar>
<div class="container">
  <router-outlet></router-outlet>
</div>

<footer class="footer">
  @if (!isMobile) {
    <ul class="nav">
      <li>
        <a href="https://stroly.com/guide/" target="_blank" rel="noopener">{{
          helpGuide
        }}</a>
      </li>
      <li>
        <a href="https://stroly.com/terms/" target="_blank" rel="noopener">{{
          terms
        }}</a>
      </li>
      <li>
        <a href="https://stroly.com/privacy/" target="_blank" rel="noopener">{{
          privacyPolicy
        }}</a>
      </li>
      <li>
        <a
          href="{{
            language == 'ja'
              ? 'https://corp.stroly.com/'
              : 'https://corp.stroly.com/en/'
          }}"
          target="_blank"
          rel="noopener"
          >{{ operatingCompany }}</a
        >
      </li>
    </ul>
  }
  <div class="copyright">
    <p>Copyright(C)Stroly All Rights Reserved.</p>
  </div>
</footer>
